module.exports = __webpack_public_path__ + "static/media/material-ui-1.726627d7.svg";